export const riddleState = {
  riddle: "",
  answer: "",
  id: null,
  submitting: false,
  previousRiddle: null,
  viewPrevious: false,
  isAnswered: false,
  reload: false,
};

export const riddleReducer = (state, action) => {
  switch (action.type) {
    case "setRiddleValue":
      return riddleStateValue(state, action.value);
    case "setSubmitting":
      return { ...state, submitting: action.value };
    case "setReload":
      return { ...state, reload: action.value };
    case "setViewPrevious":
      return { ...state, viewPrevious: action.value };
    case "clearRiddle":
      return (state = riddleState);
    default:
      return state;
  }
};

function riddleStateValue(state, value) {
  return {
    ...state,
    answer: value.answer,
    id: value.id,
    isAnswered: value.isAnswered,
    previousRiddle: value.previousRiddle,
    riddle: value.riddle,
  };
}
